import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { wrapperStyle, innerStyle, arrowToStyle } from './styles';

export const Cards = ({ children, columns, scrollable, arrowTo, arrowTop, columnsAt }) => {
	return (
		<div
			data-component="Cards"
			data-scrollable={scrollable}
			className={wrapperStyle(columns, scrollable, columnsAt)}
		>
			<div className={innerStyle}>{children}</div>
			{arrowTo && <Link to={arrowTo} className={arrowToStyle(arrowTop)} />}
		</div>
	);
};

Cards.defaultProps = {
	columns: 3,
	scrollable: true,
	arrowTop: '50%',
};

Cards.propTypes = {
	children: PropTypes.array,
	columns: PropTypes.number,
	columnsAt: PropTypes.shape({
		columnsAt: PropTypes.number,
	}),
	scrollable: PropTypes.bool,
	arrowTo: PropTypes.string,
	arrowTop: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
};



// WEBPACK FOOTER //
// ./src/components/shared/cards/component.js